export const DEFAULT_MISSING_PERMISSION_MESSAGE = 'Missing permissions' as const;
export const MAX_KEYWORDS_PERMISSION_MESSAGE = (
  maxKeywordsNums: number,
  overflowKeywordsNum: number,
) =>
  `You have reached the maximum number of keywords (${maxKeywordsNums}). You exceeded the limit by ${
    overflowKeywordsNum - maxKeywordsNums
  }.`;

export const MAX_ORGANIZATION_USERS_PERMISSION_MESSAGE = (maxUsersNum: number) =>
  `You've reached the maximum number of users allowed in the organization (${maxUsersNum}).`;

export const MAX_ORGANIZATION_WORKSPACES_PERMISSION_MESSAGE = (
  maxWorkspacesNum: number,
) =>
  `You've reached the maximum number of workspaces allowed in the organization (${maxWorkspacesNum}).`;

export const ALLOWED_SUBSCRIPTION_STATUSES = ['active', 'trialing'];
